/**
* In this file contains the Account Settings screen UI designs and forms functionality
**/
import { Link,useNavigate } from 'react-router-dom';
import { goBack } from './../../services/UtilsService';
import {useState} from 'react';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { validate } from './../../services/ValidationService';
import ApiService from './../../services/ApiService';
import {hashPassword,generatePasswordEPK,decryptPassword,encryptPassword} from './../../services/UtilsService';
import { useSelector } from 'react-redux'
import usePasswordToggle from './../../services/passwordService';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function AccountSettings () {
	
	//Variable Intialize
	const [data,setData]=useState({});
	const [error,setError]=useState({});
	const [valid,setValid]=useState(true);	
	const [match,setMatch]=useState(true);	
	const profile=useSelector(state => state?.profile);
	const [showPassword, togglePassword] = usePasswordToggle(false);
	const [showNewPassword, toggleNewPassword] = usePasswordToggle(false);
	const [showConfirmPassword, toggleConfirmPassword] = usePasswordToggle(false);
	const currentUrl = window.location.href;
	const navigate = useNavigate();
	const role = Number(localStorage.getItem('role'));
	const { t } = useTranslation();

	/**
	* Validation schema for Account Settings password
	* @password pass the password value
	* @conformpassword pass the conformpassword value
	* @currentPassword pass the current password value
	**/
   const fields = [
    { name: 'password', validation: Yup.string().required(t('error.required')).matches(/^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/, t('error.validPassword'))},
	{ name: 'conformpassword', validation: Yup.string().required(t('error.required')) },
	{ name: 'currentPassword', validation: Yup.string().required(t('error.required')) }
   ];
   
   /**
   * To handle input change function
   * @e we capture the input fields events
   **/
  const handleChange=async(e)=>{
	  e.preventDefault();
	  const {name,value}=e.target;  
	  setData({...data,[name]:value});
	  const Errors = await validate({ [name]: value }, fields);
	  setError({...error,[name]:Errors[name]});
	  if(name ==='password'){
		  var oldpass=localStorage.getItem('encyptPassword');
		  if(value===decryptPassword(oldpass)){
			 setMatch(false);
		  }else{
			  setMatch(true);
		  }
	  }
	  if(name ==='conformpassword' || name ==='password'){
		  if(value === data.password || value === data.conformpassword){
			  setValid(true);
		  }else{
			  setValid(false);
		  }
	  }
  };
  
	
	/**
	* To handel the submit
	* @e we capture the Account Settings form events
	**/
	const handelSubmit=async (e)=>{
		e.preventDefault();
		const Errors = await validate(data, fields);
	  setError(Errors);
	  if(!Object.keys(Errors).length && valid && match){
		  var value={};
		   var privateKey=localStorage.getItem('privateKey');
		   value.password=await hashPassword(data.password);
		   value.currentPassword=await hashPassword(data.currentPassword);
		   value.passwordEPK=await generatePasswordEPK(data.password,privateKey);  
		   var response = await ApiService.updatePassword(value);
		  if(response.status===200){
			  localStorage.setItem('encyptPassword', encryptPassword(data.password));
			  toast.success(response?.data?.message);
			  setData({});
			  if(currentUrl.includes('/hospital/')){
				  navigate('/hospital/admin/dashboard');
			  }else{
				  navigate('/admin/dashboard');
			  }
		  }else{
			  toast.error(response?.data?.message);
		  }
	  }
	}

	/**
	* To handle form reset
	**/
	const handleCancel=async (e)=>{
		await setData({});
		await setError({});
		await setValid(true);
	}
   
  return (
    <>
	<main id="main" className="main">
		<div className="pagetitle clearfix">
			<div className="float-start">
			  <h1>{t('header.accountSettings')}</h1>
				<nav>
					<ol className="breadcrumb">
					  <li className="breadcrumb-item">
						<Link to={
							currentUrl.includes('/hospital/') 
								? '/hospital/admin/dashboard' 
								: '/admin/dashboard'
						}>
							{t('sidebar.home')}
						</Link>
					  </li>
					  <li className="breadcrumb-item active">{t('header.accountSettings')} </li>
					</ol>
				</nav>
			</div>
			<div className="float-end mt-2 me-1">
				<span onClick={goBack} className="backIcon"><i className="iconly-Bold-ArrowLeftSquare"></i></span>
			</div>
		</div>
		<section className="pagesection">
		  <div className="row">
			<div className="col-xxl-12">
			
			{/*Account Settings Form*/}
			  <form className="form-card p-2" onSubmit={handelSubmit} autoComplete="off">
				<div className="row">
				  <div className="col-xxl-12">
					<div className={`secTitle ${role === 4 ? 'admin-secTitle' : ''}`}>
					  <h1>{t('auth.passwordSetting')}</h1>
					</div>
				  </div>
				</div>
				<div className="row">
				  <div className="col-lg-6 col-md-6">
					<div className=" form-group">
					  <label>{t('auth.userName')}</label>
					  <input
						type="text"
						className="form-control bg-light"
						defaultValue={profile?.first_name+' '+profile?.last_name}
						readOnly
					  />
					</div>
				  </div>
				  <div className="col-lg-6 col-md-6">
					<div className=" form-group" style={{"position":"relative"}}>
					  <label>{t('auth.currentPassword')} </label>
					  <input
						type={showPassword ? "text" :"password"}
						className="form-control"
						placeholder={t('auth.typeCurrentPassword')}
						value={data.currentPassword?data.currentPassword:''} name="currentPassword" onChange={handleChange} 
					  />
					  <span className="password-toggle">
						<i className={showPassword ? 'far fa-eye' : 'far fa-eye-slash'} onClick={togglePassword}></i>
					  </span>
					  {error && error.currentPassword && <span className="text-danger">{error.currentPassword}</span>}
					 </div>
				  </div>
				</div>
				<div className="row">
				  <div className="col-lg-6 col-md-6">
					<div className=" form-group" style={{"position":"relative"}}>
					  <label>{t('auth.newPassword')}</label>
					  
					  {/* OverlayTrigger Section */}
					  <OverlayTrigger trigger={['focus']} placement="right" overlay={<Popover
							id="popover-basic"
							title="Password Must:"
						  >
						  <h3 className="popover-header ng-star-inserted">{t('auth.passwordMust')}</h3>
						  <div className="popover-body">
							<label className={`col ${(!data.password || data?.password?.length < 8) ? "text-danger" : "text-success"}`}>
							  {(!data.password || data.password?.length < 8)
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {t('error.passErrorOne')}
							</label>
							<label className={`col ${(!data.password || !/\d/.test(data.password)) ? "text-danger" : "text-success"}`}>
								{(!data.password || !/\d/.test(data.password))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {t('error.passErrorTwo')}
							</label>
							<label className={`col ${(!data.password || !/[A-Z]/.test(data.password)) ? "text-danger" : "text-success"}`}>
								{(!data.password || !/[A-Z]/.test(data.password))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {t('error.passErrorThree')}
							</label>
							<label className={`col ${(!data.password || !/[a-z]/.test(data.password)) ? "text-danger" : "text-success"}`}>
								{(!data.password || !/[a-z]/.test(data.password))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {t('error.passErrorFour')}
							</label>
							<label className={`col ${(!data.password || !/[!@#$%^&*()\-_=+{};:,<.>]/.test(data.password)) ? "text-danger" : "text-success"}`}>
								{(!data.password || !/[!@#$%^&*()\-_=+{};:,<.>]/.test(data.password))
								? <i className="fa-solid fa-circle-xmark"></i>
								: <i className="fa-solid fa-circle-check"></i>} {t('error.passErrorFive')}
							</label>
							</div>
						</Popover>}>
							<input type={showNewPassword ? "text" :"password"} autoComplete="off" value={data.password?data.password:''} name="password" onChange={handleChange} className="form-control" placeholder={t('auth.typeNewPassword')} />
						</OverlayTrigger>
						{/*End OverlayTrigger Section */}
						
						<span className="password-toggle">
							<i className={showNewPassword ? 'far fa-eye' : 'far fa-eye-slash'} onClick={toggleNewPassword}></i>
						</span>
						{error && error.password && <span className="text-danger">{error.password}</span>}
						{!match && !error.password && <span className="text-danger">{t('auth.newPasswordCountNotSameAsOld')}</span>}
						</div>
				  </div>
				  <div className="col-lg-6 col-md-6">
					<div className=" form-group" style={{"position":"relative"}}>
					  <label>{t('auth.confirmPassword')}</label>
					  <input value={data.conformpassword?data.conformpassword:''} name="conformpassword" onChange={handleChange}  autoComplete="off" type={showConfirmPassword ? "text" :"password"} className="form-control" placeholder={t('auth.reTypeNewPassword')} />
					  <span className="password-toggle">
						<i className={showConfirmPassword ? 'far fa-eye' : 'far fa-eye-slash'} onClick={toggleConfirmPassword}></i>
					  </span>
					  {error && error.conformpassword && <span className="text-danger">{error.conformpassword}</span>}
						{!valid && !error.conformpassword && <span className="text-danger">{t('auth.confirmPasswordShouldNotMatch')}</span>}
					  </div>
				  </div>
				</div>
				
				{/* Button Section */}
				<div className="row">
				  <div className="col-lg-12 text-end">
					<button type="button" onClick={handleCancel} className={`btn ${role===4?'btn-tmAquaDgreen':'btn-secondary '} me-2`}>
					  <i className="ri-arrow-left-line align-middle" /> {t('common.cancel')}
					</button>
					<button
					  type="submit"
					  className={`btn ${role===4?'btn-tmAquaGreen':'btn-tmBlue'}`}
					>
					  <i className="ri-check-double-fill align-middle" /> {t('profile.submit')}
					</button>
				  </div>
				</div>
			  </form>
			  {/*End Account Settings Form*/}
			  
			</div>
		  </div>
		</section>


	</main>
    </>
  );
}

export default AccountSettings;
